if (!customElements.get('component-banner')) {
  customElements.define('component-banner', class Banner extends HTMLElement {
    constructor() {
      super();

      this.banner = this.querySelector('[data-banner]');

      window.addEventListener("scroll", () => {
        const pageHeight = document.body.scrollHeight;
        const elPos = this.banner.getBoundingClientRect();
        const elTop = elPos.top;
        const posPercentage = ((elTop / pageHeight) * 100);
        this.banner.scrollLeft = posPercentage * 10;
      });
    }
  });
}
